import React, { Component, Fragment } from 'react';
import Checkbox from '../components/global/checkbox.js';

class Step1 extends Component {
  render() {
    if (this.props.currentStep !== 1) { // Prop: The current step
      return null
    }
    const checkboxOptions = {
      'senior-decision-maker': "Senior Decision Maker",
      'fleet': "Fleet",
      'hr': "HR",
      'operations': "Operations",
    }
    // The markup for the Step 1 UI
    return(
      <div className="form-group">
        <label htmlFor="email" className="form-group__label">Job Function</label>
        <div className="checkbox-group">
          {
            Object
            .keys(checkboxOptions)
            .map(key => {
              return (
                <Checkbox id={ key } label={ checkboxOptions[key] } />
              )
            })
          }
        </div>

        <input
          className="form-control"
          id="email"
          name="email"
          type="text"
          placeholder="Enter email"
          value={this.props.email} // Prop: The email input data
          onChange={this.props.handleChange} // Prop: Puts data into state
        />
      </div>
    )
  }
}

export default Step1;
